import { Box, Divider, Stack, Typography } from "@mui/material";
import { IEventInfo } from "./EventCalendar";

interface IProps {
  event: IEventInfo;
}

const EventInfo = ({ event }: IProps) => {
  console.log({ event });

  const percentage = event?.percentage;
  const bgColor =
    percentage <= 25
      ? "red"
      : percentage <= 75
      ? "orange"
      : percentage <= 100
      ? "green"
      : "blue";
  return (
    <Stack
      direction="row"
      alignItems="end"
      justifyContent="end"
      sx={{ width: "100%", height: "135px", px: 0.5, borderRadius: 1 }}
      spacing={1}
      divider={
        <Divider
          sx={{
            border: "solid 1px",
            height: "135px",
            borderColor: "yellow",
          }}
        />
      }
    >
      <Box
        sx={{
          height: `${event?.percentage}%`,
          backgroundColor: bgColor,
          borderRadius: 1,
          width: "75%",
          textAlign: "center",
          pt: 1,
        }}
      >
        <Typography fontWeight="bold">
          {`${event?.percentage!}%` ?? "--"}
        </Typography>
      </Box>
      <Stack width="25%">
        <Typography sx={{ fontSize: 10 }} fontWeight="bold">
          {`TR: ${event?.total_receipt}`}
        </Typography>
        <Typography sx={{ fontSize: 10 }} fontWeight="bold">
          {`TP: ${event?.paid}`}
        </Typography>
        <Typography
          sx={{ fontSize: 10 }}
          fontWeight="bold"
        >{`TU: ${event?.unpaid}`}</Typography>
      </Stack>
    </Stack>
  );
};

export default EventInfo;
